const en = {
  10000001: 'SuperEx 2nd Anniversary Celebration',
  10000002: 'Sign in for great rewards!',
  10000003: 'According to the number of participants, the larger the number of participants, the larger the prize pool will be unlocked, up to 10,000USDT. ',
  10000004: 'SuperEx 2nd Anniversary',
  10000005: 'Futures Championship Win 20,000 USDT',
  10000006: 'Trading Volume Ranking Competition: Unlock the highest prize of <span style="color: #ffc72b;">10,000</span> USDT bonus pool. ',
  10000007: 'Futures Championship',
  10000008: 'Futures Championship Win 20,000 USDT',
}
export default en



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/en.js